export default __webpack_public_path__ + "static/media/gujranwala.046a443b.jpg";